"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accallio_cloud_profile_api_1 = require("@antegma/accallio-cloud-profile-api");
var env_1 = require("App/util/env");
var api_1 = require("../../api");
var env = env_1.getEnv({
    PROFILE_API_BASE_PATH: process.env.REACT_APP_PROFILE_API_BASE_PATH || 'https://profile-api.accallio.com',
});
var currentUserApi = new accallio_cloud_profile_api_1.CurrentUserApi(undefined, env.PROFILE_API_BASE_PATH, api_1.Api.instance.axiosInstance);
// Export APIs
exports.default = {
    currentUserApi: currentUserApi,
};
//# sourceMappingURL=index.js.map